import axios from "../../axios";

export default {
  async fetchKpiSummary({ commit }) {
    try {
      const res = await axios.get("/api/analytics/kpi-summary");
      commit("SET_KPI_SUMMARY", res.data.data);
    } catch (error) {
      console.log(error);
    }
  },

  async fetchRevenueOverTime({ commit }, { period = "daily", days = 30 } = {}) {
    try {
      const res = await axios.get(
        `/api/analytics/revenue-over-time?period=${period}&days=${days}`
      );
      commit("SET_REVENUE_OVER_TIME", res.data.data);
    } catch (error) {
      console.log(error);
    }
  },

  async fetchPeakHours({ commit }, { days = 30 } = {}) {
    try {
      const res = await axios.get(`/api/analytics/peak-hours?days=${days}`);
      commit("SET_PEAK_HOURS", res.data.data);
    } catch (error) {
      console.log(error);
    }
  },

  async fetchProductPerformance({ commit }, { limit = 10 } = {}) {
    try {
      const res = await axios.get(
        `/api/analytics/product-performance?limit=${limit}`
      );
      commit("SET_PRODUCT_PERFORMANCE", res.data.data);
    } catch (error) {
      console.log(error);
    }
  },

  async fetchOrderSources({ commit }, { days = 30, period = "daily" } = {}) {
    try {
      const res = await axios.get(
        `/api/analytics/order-sources?days=${days}&period=${period}`
      );
      commit("SET_ORDER_SOURCES", res.data.data);
    } catch (error) {
      console.log(error);
    }
  },

  async fetchPaymentMethods({ commit }, { days = 30 } = {}) {
    try {
      const res = await axios.get(
        `/api/analytics/payment-methods?days=${days}`
      );
      commit("SET_PAYMENT_METHODS", res.data.data);
    } catch (error) {
      console.log(error);
    }
  },

  async fetchCustomerStats({ commit }) {
    try {
      const res = await axios.get("/api/analytics/customer-stats");
      commit("SET_CUSTOMER_STATS", res.data.data);
    } catch (error) {
      console.log(error);
    }
  },

  async fetchOperations({ commit }) {
    try {
      const res = await axios.get("/api/analytics/operations");
      commit("SET_OPERATIONS", res.data.data);
    } catch (error) {
      console.log(error);
    }
  },

  async fetchOrderLocations({ commit }) {
    try {
      const res = await axios.get("/api/analytics/order-locations");
      commit("SET_ORDER_LOCATIONS", res.data.data);
    } catch (error) {
      console.log(error);
    }
  },

  async fetchRevenueByPayment(
    { commit },
    { period = "daily", days = 30 } = {}
  ) {
    try {
      const res = await axios.get(
        `/api/analytics/revenue-by-payment?period=${period}&days=${days}`
      );
      commit("SET_REVENUE_BY_PAYMENT", res.data.data);
    } catch (error) {
      console.log(error);
    }
  },

  async fetchWeekdayHeatmap({ commit }, { days = 90 } = {}) {
    try {
      const res = await axios.get(
        `/api/analytics/weekday-heatmap?days=${days}`
      );
      commit("SET_WEEKDAY_HEATMAP", res.data.data);
    } catch (error) {
      console.log(error);
    }
  },

  async fetchAvgOrderValue({ commit }, { period = "daily", days = 30 } = {}) {
    try {
      const res = await axios.get(
        `/api/analytics/avg-order-value?period=${period}&days=${days}`
      );
      commit("SET_AVG_ORDER_VALUE", res.data.data);
    } catch (error) {
      console.log(error);
    }
  },

  async fetchRevenueByArea({ commit }) {
    try {
      const res = await axios.get("/api/analytics/revenue-by-area");
      commit("SET_REVENUE_BY_AREA", res.data.data);
    } catch (error) {
      console.log(error);
    }
  },

  async fetchNewVsReturning({ commit }, { days = 90 } = {}) {
    try {
      const res = await axios.get(
        `/api/analytics/new-vs-returning?days=${days}`
      );
      commit("SET_NEW_VS_RETURNING", res.data.data);
    } catch (error) {
      console.log(error);
    }
  },

  async fetchPopularIngredients({ commit }) {
    try {
      const res = await axios.get("/api/analytics/popular-ingredients");
      commit("SET_POPULAR_INGREDIENTS", res.data.data);
    } catch (error) {
      console.log(error);
    }
  },

  async fetchAddressMap({ commit }) {
    try {
      const res = await axios.get("/api/analytics/address-map");
      commit("SET_ADDRESS_MAP", res.data);
    } catch (error) {
      console.log(error);
    }
  },

  async fetchAllAnalytics({ dispatch }) {
    await Promise.all([
      dispatch("fetchKpiSummary"),
      dispatch("fetchRevenueOverTime"),
      dispatch("fetchPeakHours"),
      dispatch("fetchProductPerformance"),
      dispatch("fetchOrderSources"),
      dispatch("fetchPaymentMethods"),
      dispatch("fetchCustomerStats"),
      dispatch("fetchOperations"),
      dispatch("fetchOrderLocations"),
      dispatch("fetchRevenueByPayment"),
      dispatch("fetchWeekdayHeatmap"),
      dispatch("fetchAvgOrderValue"),
      dispatch("fetchRevenueByArea"),
      dispatch("fetchNewVsReturning"),
      dispatch("fetchPopularIngredients"),
      dispatch("fetchAddressMap"),
    ]);
  },
};
